import { apiContainer } from '@vlabs/api-bindings';
import i18n from 'i18next';
import { toast } from 'react-toastify';

import { confirmDeleteFace } from './confirmDeleteFace';

interface DeleteFaceProps {
  faceId: string;
  onSuccess?: VoidFunction;
}

export function deleteFace({
  faceId, onSuccess = undefined,
}: DeleteFaceProps): void {
  const onConfirm = async (): Promise<void> => {
    try {
      await apiContainer.lunaClient.faces.delete(faceId);
      toast.success(i18n.t('features:deleteFace.toast.success'));
      onSuccess?.();
    } catch {
      toast.error(i18n.t('features:deleteFace.toast.error'));
    }
  };

  confirmDeleteFace({ onConfirm });
}
